import { getBaseUrl } from "@/lib/utils/get-base-url";

const DP_HEADERS = {
  "Content-Type": "application/json",
  "x-internal-client": "DIGITAL_PROFILE",
  "x-channel": "CONTRACTOR_WEB",
};

const EMPTY_PAGE = (page, limit) => ({
  data: [],
  pagination: { page, pageSize: limit, pageCount: 0, total: 0 },
});

/**
 * find-contractors/[city]'s one real backend call: only LG_LIVE contractors
 * are ever returned (server-side eligibility, not filterable from here).
 */
export async function fetchLeadGenProfiles({
  page = 1,
  limit = 25,
  sort,
  filters,
} = {}) {
  const body = { page, limit };
  if (sort?.length) body.sort = sort;
  if (filters && Object.keys(filters).length > 0) body.filters = filters;

  try {
    const response = await fetch(`${getBaseUrl()}/v2/api/lead-gen/profiles`, {
      method: "POST",
      headers: DP_HEADERS,
      credentials: "include",
      body: JSON.stringify(body),
      next: { revalidate: 300 },
    });

    if (!response.ok) return EMPTY_PAGE(page, limit);

    const json = await response.json();
    return json?.result?.data ?? EMPTY_PAGE(page, limit);
  } catch (error) {
    console.error("Error fetching lead gen profiles:", error);
    return EMPTY_PAGE(page, limit);
  }
}
